import db from '@/firebase/init'
import {firestore} from 'firebase/app'

export async function getTags (uid) {
  const tags = db.collection(process.env.VUE_APP_DB_TAGS).where('blogId', '==', uid)
  const data = []
  await tags.get()
    .then(snapshot => {
      snapshot.forEach(doc => {
        data.push(doc.data().tag)
      })
    })
    .catch(err => {
      console.log('Error getting documents', err)
    })
  return data
}

export function sanitizeTitle (title) {
  let slug = ''
  // Change to lower case
  const titleLower = title.toLowerCase()
  // Letter "e"
  slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e')
  // Letter "a"
  slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a')
  // Letter "o"
  slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o')
  // Letter "u"
  slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u')
  // Letter "d"
  slug = slug.replace(/đ/gi, 'd')
  // Trim the last whitespace
  slug = slug.replace(/\s*$/g, '')
  // Change whitespace to "-"
  slug = slug.replace(/\s+/g, '-')

  return slug
}

export function postBlogToFirebase (blog, selectedCoverImage, author, title, status, tags) {
  const date = new Date()
  db.collection(process.env.VUE_APP_DB_BLOGS).add({
    author: author,
    body: blog.body,
    coverImage: selectedCoverImage,
    slug_name: sanitizeTitle(title),
    title: title,
    date_created: firestore.Timestamp.fromDate(date),
    date_edited: firestore.Timestamp.fromDate(date),
    published: status
  })
    .then(ref => {
    // set the documentID on the database
      db.collection(process.env.VUE_APP_DB_BLOGS).doc(ref.id).update({ uid: ref.id })
      // add new tags to the database
      tags.forEach((value) => {
        db.collection(process.env.VUE_APP_DB_TAGS).add({
          blogId: ref.id,
          tag: value
        })
      })
    })
    .catch(function (error) {
      console.error('Error writing document: ', error)
    })
}

export function editBlogToFirebase (blog, blogUid, selectedCoverImage, author, title, status, tags, project:boolean) {
  console.log('editBlogToFirebaseFunction')
  console.log(blogUid)
  const date = new Date()
  db.collection(process.env.VUE_APP_DB_BLOGS).where('uid', '==', blogUid)
    .get()
    .then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        console.log(doc.id, ' => ', doc.data())
        // Build doc ref from doc.id
        db.collection(process.env.VUE_APP_DB_BLOGS).doc(doc.id).update({
          author: author,
          body: blog.body,
          coverImage: selectedCoverImage,
          slug_name: sanitizeTitle(title),
          title: title,
          date_edited: firestore.Timestamp.fromDate(date),
          published: status, 
          project: project
        })
      })
    })
}

export async function deleteBlog (uid) {
  const blog = db.collection(process.env.VUE_APP_DB_BLOGS).doc(uid)
  await blog.delete()
}
